import axiosIns from '@/xaxios';
import gql from 'graphql-tag';

export const headers = () => {
  return [
    { text: 'contacto', value: 'nombre_completo' },
    { text: 'origen', value: 'origen' },
    { text: 'area interes', value: 'area_interes_name' },
    { text: 'profesion', value: 'profesion_name' },
    { text: 'programa interes', value: 'programa_interes_name' },
    { text: 'estado', value: 'estado' },
    { text: '', value: 'opt' },
  ];
};

export const headers2 = () => {
  return [
    { text: 'Nombre de la persona', value: 'persona_name' },
    { text: 'programa', value: 'programa_name' },
    { text: 'sede', value: 'sede_name' },
    { text: 'estado', value: 'estado' },
    // { text: 'fecha_conversion', value: 'fecha_conversion' },
    { text: 'observaciones', value: 'observaciones' },
    { text: '', value: 'opt' },
  ];
};

export const headers3 = () => {
  return [
    { text: 'prospecto', value: 'persona_name' },
    { text: 'programa', value: 'programa_name' },
    { text: 'tipo inscripcion', value: 'tipo_inscripcion' },
    { text: 'plan de pago', value: 'plan_pago' },
    { text: 'sede', value: 'sede_name' },
    { text: 'estado', value: 'estado' },
    { text: 'observaciones', value: 'observaciones' },
    { text: 'fecha inscripcion', value: 'fecha_inscripcion' },
    { text: '', value: 'opt' },
  ];
};

export const tipos_inscripcion = () => {
  return ['POSGRADUAL', 'INTERNACIONAL', 'MODULAR'];
};
export const plan_pagos = () => {
  return ['CREDITO', 'CONTADO'];
};

export const getAreas = async (thiz, unidad) => {
  const sql = gql`query{getAreas(unidad_negocio_id:${unidad}){id,nombre,unidad_negocio_id}}`;
  return await thiz.$apollo
    .query({ query: sql })
    .then(({ data }) => data)
    .catch((error) => error);
};

export const getSedes = async (vue) => {
  const qs = gql` query {getSedes ${''} {id, nombre,unidad_negocio }}`;
  return await vue.$apollo
    .query({ query: qs })
    .then(({ data: { getSedes } }) => getSedes)
    .catch(() => []);
};

export const listarprogramasgraphql = async (vue, idsede, gestion) => {
  const gestionParam = gestion ? `,gestion:${gestion}` : '';
  var sql = gql`query{ getProgramas(cursor:1000000,estado:true,idsede:${idsede}${gestionParam}){ id,fase,version,grupo,estado,codigo,nombre_compuesto} }`;
  const res = await vue.$apollo
    .query({ query: sql, variables: {} })
    .then(({ data }) => data)
    .catch((e) => e);
  if (res && res.getProgramas) {
    let datos = res.getProgramas;
    datos.forEach((x, indice) => {
      if (!x.codigo) x.text = `${indice + 1}.- ${x.nombre_compuesto}`;
      else x.text = `${indice + 1}.- [${x.codigo}] ${x.nombre_compuesto}`;

      x.text += ` fase: ${x.fase}`;
      x.value = x.id;
    });
    return datos;
  }
  return [];
};

export const getContactos = async (q) => {
  const query = `
    query contactos($q: QueryContactos!) {
      contactos(q: $q) {
        id
        nombres
        apellidos
        asesor_id
        asesor_name
        origen_id
        origen
        area_interes_id
        area_interes_name
        profesion_id
        profesion_name
        programa_interes_id
        programa_interes_name
        estado
        telefono
        correo
        observaciones
        fecha_registro
      }
    }
  `; 
  const response = await axiosIns.post(process.env.VUE_APP_PROSPECTOS_API, {
    query,
    variables: { q },
  });
  
  if(response.data.data){
    const contactos = response.data.data.contactos
    return contactos;
  }else{
    return {
      error: response.data.errors[0].message
    }
  }
};

export const getProspectos = async (q) => {
  const query = `
  query prospectos($q:QueryProspectos!){
    prospectos(q:$q){
      id
      contacto_id
      persona_name
      persona_id 
      programa_id
      programa_name
      estado
      fecha_conversion
      observaciones
      sede_id
      sede_name
    }
  }
  `;

  const response = await axiosIns.post(process.env.VUE_APP_PROSPECTOS_API, {
    query,
    variables: { q },
  });
  return response.data.data.prospectos;
};

export const getPreregistros = async (q) => {
  const query = `
  query pre_registros($q:QueryPreRegistros!){
    pre_registros(q:$q){
      id
      prospecto_id
      persona_name
      programa_id
      programa_name
      sede_id
      sede_name
      asesor_id
      persona_id
      tipo_inscripcion
      plan_pago
      estado
      promocion_id
      contadora_id
      fecha_validacion
      observaciones
      fecha_inscripcion
      documentos{
        id
        pre_registro_id
        tipo
        nombre_archivo
        url_archivo
        obligatorio
        fecha_carga
      }
    }
  }
  `;

  const response = await axiosIns.post(process.env.VUE_APP_PROSPECTOS_API, {
    query,
    variables: { q },
  });
  return response.data.data.pre_registros;
};

export const getOrigenesContacto = async () => {
  const query = `
    query origenes_contacto{
        origenes_contacto{
            id
            nombre
            activo
        }
    }
  `;

  const response = await axiosIns.post(process.env.VUE_APP_PROSPECTOS_API, { query });
  return response.data.data.origenes_contacto;
};

export const getFileServer = async (uid) => {
  const query = `
  query get_file_server($uid:ID!){
    get_file_server(uid:$uid)
  }
  `;

  const response = await axiosIns.post(process.env.VUE_APP_PROSPECTOS_API, {
    query,
    variables: { uid },
  });
  return response.data.data.get_file_server;
};

export const createContacto = async (input) => {
  const query = `
    mutation createContacto($input: NewContacto!) {
      createContacto(input: $input) {
        id
        
        asesor_id
        asesor_name
        origen_id
        origen
        area_interes_id
        area_interes_name
        programa_interes_id
        programa_interes_name
        estado
        observaciones
        fecha_registro
      }
    }
  `;

  const response = await axiosIns.post(process.env.VUE_APP_PROSPECTOS_API, {
    query,
    variables: { input },
  });

  if(response.data.data){
    const createContacto = response.data.data.createContacto
    return createContacto;
  }else{
    return {
      error: response.data.errors[0].message
    }
  } 
};

export const createProspecto = async (input) => {
  const query = `
  mutation createProspecto($input:NewProspecto!){
    createProspecto(input:$input){
      id
      contacto_id
      persona_name
      programa_id
      programa_name
      estado
      fecha_conversion
      observaciones
    }
  }
  `;

  const response = await axiosIns.post(process.env.VUE_APP_PROSPECTOS_API, {
    query,
    variables: { input },
  });
  
  if(response.data.data){
    const createProspecto = response.data.data.createProspecto
    return createProspecto;
  }else{
    return {
      error: response.data.errors[0].message
    }
  } 
};

export const createPreRegistro = async (input) => {
  const query = `
  mutation createPreRegistro($input:NewPreRegistro!){
    createPreRegistro(input:$input){
      id
      prospecto_id
      tipo_inscripcion
      plan_pago
      estado
      promocion_id
      contadora_id
      fecha_validacion
      observaciones
      fecha_inscripcion
    }
  }
  `;

  const response = await axiosIns.post(process.env.VUE_APP_PROSPECTOS_API, {
    query,
    variables: { input },
  });
  if(response.data.data){
    const createPreRegistro = response.data.data.createPreRegistro
    return createPreRegistro;
  }else{
    return {
      error: response.data.errors[0].message
    }
  }
};

export const setVerificacion_contable = async (input) => {
  const query = `
  mutation verificacion_contable($input:NewVerConta!){
    verificacion_contable(input:$input){
      id
      prospecto_id
      estado
      contadora_id
      contadora_name
    }
  }
  `;

  const response = await axiosIns.post(process.env.VUE_APP_PROSPECTOS_API, {
    query,
    variables: { input },
  });
  if(response.data.data){
    const verificacion_contable = response.data.data.verificacion_contable
    return verificacion_contable;
  }else{
    return {
      error: response.data.errors[0].message
    }
  }
};

export const update_prospecto_estado = async (input) => {
  const query = `
  mutation update_prospecto_estado($input: UpdProspectoEstado!){
    update_prospecto_estado(input:$input){id estado}
  }
  `;

  const response = await axiosIns.post(process.env.VUE_APP_PROSPECTOS_API, {
    query,
    variables: { input },
  });
  if(response.data.data){
    const update_prospecto_estado = response.data.data.update_prospecto_estado
    return update_prospecto_estado;
  }else{
    return {
      error: response.data.errors[0].message
    }
  }
};

export const headersPreinscritos = () => {
  return [
    { text: 'Estudiante', value: 'nombre_completo' },
    { text: 'Documento', value: 'num_doc' },
    { text: 'Teléfono', value: 'telefono' },
    { text: 'Correo', value: 'email' },
    { text: 'Programa', value: 'programa' },
    { text: 'Sede', value: 'sede' },
    { text: 'Fecha registro', value: 'fecha_registro' },
    { text: 'Estado', value: 'estado_ins' },
    { text: '', value: 'opt' },
  ];
};

export const getMisInscripciones = async (vue, fechas) => {
  const sql = gql`query{
    misInscripciones(fechas:{fecha_ini:"${fechas.fecha_ini}",fecha_fin:"${fechas.fecha_fin}"}){
      id
      idprograma
      idestudiante
      idasesor
      estado_ins
      fecha_registro
      estudiante{ id, num_doc, nombres, pri_apellido, seg_apellido, telefono1, email }
      programa{ id, codigo, nombre_compuesto, sede{ nombre } }
    }
  }`;
  return await vue.$apollo
    .query({ query: sql, fetchPolicy: 'no-cache' })
    .then(({ data }) => data.misInscripciones || [])
    .catch(() => []);
};

export const parseNombreCompleto = (str) => {
  if (!str || typeof str !== "string") {
    throw new Error("Entrada inválida");
  }

  // Limpiar espacios extra
  const partes = str.trim().split(/\s+/);

  if (partes.length < 2) {
    throw new Error("Debe tener al menos un nombre y un apellido");
  }

  let nombres = "";
  let pri_apellido = "";
  let seg_apellido = "";

  if (partes.length === 2) {
    // 1 nombre + 1 apellido
    nombres = partes[0];
    pri_apellido = partes[1];
  } else {
    // 3 o más palabras
    seg_apellido = partes.pop();         // último
    pri_apellido = partes.pop();         // penúltimo
    nombres = partes.join(" ");          // resto
  }

  return {
    nombres,
    pri_apellido,
    seg_apellido
  };
}